import { useUserOrganization } from '@modules-deprecated/app/organization'
import { useUserOrganizationMembership } from '@modules-deprecated/app/organization/hooks/useUserOrganizationMembership'

export const useIsFrenchUmbrellaOrganization = (): boolean => {
  const { organization } = useUserOrganization()
  const { isViaUmbrella } = useUserOrganizationMembership()

  return organization?.countryId === 'FR' && isViaUmbrella
}
